module.exports = __webpack_public_path__ + "media/images/icons/country_flags/af-4e045b3d54d73603dc0aeb7e47085009.svg";